import { GeofenceCategory } from '@cobliteam/common-types';
import { colors } from '@cobliteam/ui/theme';
import { css, keyframes } from 'emotion';

// Remove navbar height
export const map = css`
  height: 100%;
  width: 100%;

  .leaflet-marker-icon {
    background: none;
    border: none;
  }
`;

export const plannedRoutePath = css`
  stroke: ${colors.primary[9]};
  stroke-width: 5;
  stroke-dasharray: 10;
  filter: drop-shadow(0px 4px 4px rgba(7, 7, 78, 0.2));
`;

export const routePath = css`
  cursor: default;
  stroke: ${colors.gray[12]};
  stroke-width: 5;
  stroke-opacity: 1;
  filter: drop-shadow(0px 4px 4px rgba(7, 7, 78, 0.2));
`;

const categoryColor = (category?: GeofenceCategory) => {
  switch (category) {
    case GeofenceCategory.BASE:
      return colors.primary[9];
    case GeofenceCategory.CLIENT:
      return colors.success[9];
    case GeofenceCategory.OTHER:
      return colors.warning[9];
    default:
      return colors.gray[10];
  }
};

export const geofence = (category?: GeofenceCategory) => css`
  stroke: ${categoryColor(category)};
  stroke-width: 1;
  stroke-dasharray: 3, 6;
  fill: ${categoryColor(category)};
  fill-opacity: 0.1;
`;

const strokeAnimation = keyframes`
  0% {
    stroke-dashoffset: 100%;
  }

  100% {
    stroke-dashoffset: 0;
  }
`;

export const routePathAnimation = css`
  ${routePath}
  stroke: ${colors.gray[10]};
  stroke-dasharray: 20, 80;
  animation: 25s ${strokeAnimation} linear infinite;
`;

export const textPopup = css`
  width: 230px;
`;

export const footerPopup = css`
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
`;

export const popup = css`
  box-shadow: 2px 2px 10px 0 rgba(157, 169, 182, 0.2);
  border: 1px solid ${colors.gray[6]};
  border-radius: 5px;
  box-sizing: content-box;
  background-color: ${colors.white.DEFAULT};

  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: inherit;
  }

  .leaflet-popup-content {
    margin: 0;
    border-radius: inherit;
  }
`;
